// extracted by mini-css-extract-plugin
export default {"labelBlock":"LabelBlock_labelBlock__AXwAz","fluid":"LabelBlock_fluid__HVl5X"};